"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      fontFamily: theme.typography.fontFamily
    },
    title: {
      color: theme.palette.primary.main,
      fontSize: "2.25rem",
      fontWeight: "200",
      margin: "0 0 0.35em 0"
    },
    description: {
      color: theme.palette.text.secondary,
      fontSize: ".85rem",
      lineHeight: "1.15rem",
      margin: "0 0 0.35em 0"
    }
  };
};

exports.styles = styles;